import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import last from 'lodash.last';
import { DECODING_SUBSCORE_MEASURES_LABELS } from '../../../../../constants/reading/MeasuresConstants';
import './SubscoreCategories.scss';

const renderSubscoreCategory = (subscoreKey, lastSubscoresKey, { score, maxScore }) => (
    <Fragment key={subscoreKey}>
        <div className="d-flex flex-column justify-content-center">
            <h5 className="sub-category-label">{DECODING_SUBSCORE_MEASURES_LABELS[subscoreKey]}</h5>
            <span className="sub-category-score">
                Score:{' '}
                <strong>
                    {score}/{maxScore}
                </strong>
            </span>
        </div>
        {subscoreKey !== lastSubscoresKey && <div className="dots-separate" />}
    </Fragment>
);

const SubscoreCategories = ({ subscores }) => {
    const subscoresKeys = Object.keys(subscores);
    const lastSubscoresKey = last(subscoresKeys);

    return (
        <div className="container sub-categories-wrapper">
            {subscoresKeys.map(subscoreKey =>
                renderSubscoreCategory(subscoreKey, lastSubscoresKey, subscores[subscoreKey]),
            )}
        </div>
    );
};

SubscoreCategories.defaultProps = {
    subscores: {},
};

SubscoreCategories.propTypes = {
    subscores: PropTypes.object,
};

export default SubscoreCategories;
